// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageStateByPath } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { useSelector } from "react-redux";

const usePageType = (options?: Toolkit.GoogleAnalytics.Options) => {
    return useSelector((state: ApplicationState) => {
        return getPageStateByPath(state, state.data.pages.location.pathname).value?.type;
    });
};

export default usePageType;
